export default __webpack_public_path__ + "static/media/cow_v2.f721acdb.svg";